import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { useReceipts } from '../hooks/useReceipts.js';
import { formatCurrency } from '../lib/format.js';
import ReceiptSheet from './ReceiptSheet.jsx';

const GROUPS = [
  { status: 'to_confirm', label: (n) => `${n} ticket${n > 1 ? 's' : ''} à valider`, cls: 'bg-amber-50 text-amber-900 ring-amber-200' },
  { status: 'pending', label: (n) => `${n} ticket${n > 1 ? 's' : ''} en attente du paiement`, cls: 'bg-slate-50 text-slate-800 ring-slate-200' },
  { status: 'unmatched', label: (n) => `${n} ticket${n > 1 ? 's' : ''} non rattaché${n > 1 ? 's' : ''}`, cls: 'bg-slate-50 text-slate-800 ring-slate-200' },
];

export default function PendingReceiptsBanner() {
  const { data } = useReceipts();
  // Instantané : le ticket validé disparaît de la liste après invalidation, la feuille doit rester ouverte sur le succès.
  const [opened, setOpened] = useState(null);
  const items = data?.items ?? [];
  return (
    <>
      {items.length > 0 && (
      <div className="space-y-2">
        {GROUPS.map(({ status, label, cls }) => {
          const list = items.filter((r) => r.status === status);
          if (list.length === 0) return null;
          return (
            <section key={status} className={`rounded-xl p-3 ring-1 ${cls}`}>
              <h2 className="text-sm font-semibold">{label(list.length)}</h2>
              <ul className="mt-1 divide-y divide-black/5">
                {list.map((r) => (
                  <li key={r.id}>
                    <button
                      type="button"
                      onClick={() => setOpened(r)}
                      className="flex min-h-11 w-full items-center gap-2 text-left text-sm"
                    >
                      <span className="min-w-0 flex-1 truncate">
                        {r.extracted?.merchant || r.extracted?.label || 'Ticket'}
                      </span>
                      <span className="shrink-0 tabular-nums">
                        {r.extracted?.amount_cents != null ? formatCurrency(Math.abs(r.extracted.amount_cents)) : '—'}
                      </span>
                      <ChevronRight size={16} className="shrink-0 opacity-40" aria-hidden />
                    </button>
                  </li>
                ))}
              </ul>
            </section>
          );
        })}
      </div>
      )}
      <ReceiptSheet open={Boolean(opened)} onClose={() => setOpened(null)} receipt={opened} />
    </>
  );
}
